import React, { useEffect, useState } from "react";
import Emitter from "../emitter";
import { DISPLAY_UI, FORCE_UI, HIDE_UI } from '../emitter/UIEvents'

const UIContext = React.createContext(null);

export const UIProvider = (props) => {
  const { children } = props;

  const [isUIShown, setUIShown] = useState(true);
  const [isUIForced, setUIForced] = useState(true);

  useEffect(() => {
    Emitter.on(FORCE_UI, (forcedValue) => {
      setUIForced(forcedValue);
    })
    Emitter.on(DISPLAY_UI, () => {
      setUIShown(true);
    });
    Emitter.on(HIDE_UI, () => {
      setUIShown(false);
    });
    return () => {
      Emitter.off(DISPLAY_UI);
      Emitter.off(HIDE_UI);
    };
  }, []);

  return <UIContext.Provider value={isUIForced || isUIShown}>{children}</UIContext.Provider>;
};

export const useUIShown = () => React.useContext(UIContext);
